import { useEffect, useState } from 'react';

let loading: Promise<string> | undefined;

/**
 * The product name shown in the shell header, from the deployment's `branding.json` (packages/config/public, same
 * file as the "Powered by" note, replaceable without a rebuild). Empty until loaded or when the file has none.
 */
export function useProductName(): string {
  const [name, setName] = useState('');
  useEffect(() => {
    let current = true;
    loading ??= globalThis
      .fetch(`${import.meta.env.BASE_URL}branding.json`, { cache: 'no-cache' })
      .then((response): Promise<{ productName?: string }> => (response.ok ? response.json() : Promise.resolve({})))
      .then((branding) => branding.productName ?? '')
      .catch(() => {
        loading = undefined;
        return '';
      });
    void loading.then((value) => current && setName(value));
    return () => {
      current = false;
    };
  }, []);
  return name;
}
